__webpack_require__.p = "/IndiCASA-webpage/";